import React from 'react';
import { classIf } from '../utils';

export default function EventScores(props) {
    const scores = props.scores;

    return (
        <>
            {scores.map((s, i) =>
                <td key={i} className={"cartEvent__score__td" + classIf(i === 0, 'cartEvent__score__td--live')}>
                    <div className="cartEvent__score">{props.type === 1 ? s.s1 : s.s2}</div>
                </td>
            )}
        </>
    );
}
